import { Trans, useTranslation } from 'react-i18next'
import {
  Dialog,
  Inline,
  Button,
  Text,
  Columns,
  Column,
  IconVisibilityOff,
  IllustrationWarning
} from '@machobear/design-system'

type Props = {
  visible: boolean
  onClose: () => void
  onClick: () => void
  isImported: boolean
  tag?: string[]
}
const ListingHiddenModal = ({ visible, onClose, onClick, isImported, tag }: Props) => {
  const { t } = useTranslation()

  const handleClick = () => {
    onClick()
    onClose()
  }

  return (
    <Dialog
      id="listing-hidden-modal"
      width="xsmall"
      open={visible}
      illustration={<IllustrationWarning />}
      title={t(
        'l.listing.view.listing_hidden_modal.title',
        'This listing is hidden from public search.'
      )}
      description={
        <Inline align="center" space="none">
          <Text tone="tertiary">
            {t('l.listing.view.listing_hidden_modal.text', 'Do you want to unhide this listing?')}
          </Text>
        </Inline>
      }
      onClose={onClose}
    >
      <Columns space="xsmall">
        <Column>
          <Button onClick={onClose} variant="ghost">
            {t('common.cancel', 'Cancel')}
          </Button>
        </Column>
        <Column>
          <Button icon={!isImported ? <IconVisibilityOff /> : undefined} onClick={handleClick}>
            {isImported ? (
              <Trans
                i18nKey="l.listing.edit_listing_trreb.button.text"
                t={t}
                values={{ abbreviation: tag }}
              >
                Go to {{ tag }}
              </Trans>
            ) : (
              t('l.chat.view.unhide.button', 'Unhide')
            )}
          </Button>
        </Column>
      </Columns>
    </Dialog>
  )
}

export default ListingHiddenModal
